// Exact former defaults only: read-only rebasing never changes authored text or raw storage.
export const thanksBeingLateLegacy = {
  "title": "TKS for Being Late — humain first avec l’IA",
  "family": "Culture & humains",
  "importance": "critique",
  "ownerIds": [
    "db",
    "ed",
    "eh",
    "rd"
  ],
  "tags": [
    "TKS for Being Late",
    "IA",
    "humain first",
    "adaptation",
    "simplicité"
  ],
  "summary": "Transformer la source TKS for Being Late en référence CE : le monde accélère, mais la réponse BZ doit rester humaine, simple, claire et orientée apprentissage.",
  "whyNow": "Le virage IA de BZ peut créer énormément de vitesse, mais aussi de la confusion. Cette carte sert à ralentir juste assez pour aligner le pourquoi, les rôles et la force humaine de BZ avant d’accélérer.",
  "enrichedContext": [
    "Source explicite : Thank You for Being Late: An Optimist’s Guide to Thriving in the Age of Accelerations, Thomas L. Friedman — résumé interne nommé par Dany “TKS for being late”.",
    "Idée centrale : technologie, mondialisation et climat accélèrent ensemble; les organisations doivent apprendre plus vite sans perdre leur jugement humain.",
    "Lecture BZ / AIKUB : l’IA ne réduit pas l’importance de l’humain; elle rend le jugement, la confiance, la proximité client, l’humilité et le gros bon sens encore plus importants.",
    "Cette carte prolonge le courriel V2.0 envoyé à Sonia et Félix : elle garde la version courte comme message simple, mais ajoute la profondeur nécessaire pour guider l’atelier."
  ],
  "questions": [
    "Où BZ doit-il ralentir pour mieux comprendre avant d’accélérer avec l’IA?",
    "Quels rôles doivent être clarifiés pour que les personnes clés comprennent le virage IA sans se sentir perdues?",
    "Comment garder plaisir, simplicité, humilité et respect dans un monde de plus en plus virtuel?",
    "Quels irritants humains l’IA doit enlever en premier au lieu d’ajouter une autre couche de complexité?"
  ],
  "decisions": [
    "Adopter “la force de BZ reste l’humain” comme principe directeur du virage IA.",
    "Définir 3 comportements de gestion qui protègent la simplicité et la clarté pendant l’accélération IA.",
    "Choisir les rôles ou départements qui auront besoin du plus grand accompagnement humain dans la transition.",
    "Utiliser cette carte comme référence future pour expliquer pourquoi BZ accélère, mais ne se déshumanise pas."
  ],
  "signals": [
    "La première version du résumé était bonne mais trop courte pour servir de référence durable.",
    "La V2.0 relie la source à BZ / AIKUB, au CE, au lac à l’épaule 2026 et à l’orientation 2027.",
    "Plus le monde devient virtuel, plus les liens humains deviennent précieux."
  ],
  "evidence": [
    "Source : TKS for Being Late / Thank You for Being Late — Thomas L. Friedman",
    "Courriel V2.0 Sonia + Félix : résumé exécutif, différence entre V1/V2 et raison des deux courriels",
    "Invitation Lac à l’épaule Orientation BZ 2027 : plaisir, simplicité, humilité, respect et force humaine BZ"
  ]
};
